import { KeyValuePair } from './models/key-value-pair/key-value-pair';

// Consider changing enumType: object to enumType: Record<string, unknown> per 
// TS Issue: Don't use `object` as a type. The `object` type is currently hard to use.
// ([see this issue](https://github.com/microsoft/TypeScript/issues/21732)).

export const listToFlagEnum = (enumType: object, list: number[]): number => 
    (list || [])
        .reduce((sum, o)=> sum + o, 0);

export const getAllEnumValues = (enumType: object): number[] => 
    Object.keys(enumType)
        .map(Number)
        .filter(Boolean);

export const getAllEnumPairs = (enumType: object): KeyValuePair[] => 
    Object.keys(enumType)
        .map(Number)
        .filter(Boolean)
        .map(o => new KeyValuePair(o, enumType[o]));

export const flagToListEnum = (enumType: object, value: number): number[] => 
    getAllEnumValues(enumType)
        .filter(o => (value & o) === o);

export function addSpacesToEnum(enumType: object, value: number) {
    return enumType[value].replace(/([A-Z])/g, ' $1').trim();
}

export function enumHasFlag(enumValue: number, flag: number) {
    return (enumValue & flag) === flag;
}